var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.216 0l-2.57 28.797L14.09 32 2.568 28.801 0 0h28.216z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.445 26.963L25.64 2.355H14.108v27.197l9.337-2.589z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.887 13.037l.316 3.532h7.905v-3.532H5.887zM14.108 5.887H5.25l.322 3.533h8.536V5.887zM14.108 25.886V22.21l-.016.004-3.934-1.063-.251-2.817H6.361l.495 5.546 7.236 2.01.016-.005z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.445 16.57l-.41 4.58-3.94 1.064v3.675l7.242-2.007.053-.597.83-9.3.087-.948.637-7.15h-8.848V9.42h4.977l-.321 3.617h-4.656v3.532h4.35z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.8120095c7e26e765b547ba6420c0245b.svg";
export { ForwardRef as ReactComponent };